export default __webpack_public_path__ + "images/icons/navigation-blue-bc11be17df626481141c635b305ba509.svg";